import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import './Businessslider.css';
import locationnew from '../../assets/images/icons/locationnew.svg'

class BusinessForSaleSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    service_image_err = (ev) => {
        ev.target.src = require("../../assets/images/default_service_image.png");
    }

    render() {
        const { businesses } = this.props;
console.log('businesses', businesses);
        return (
            <div className="business-grid">
                {
                    businesses &&
                    businesses.map((business, index) => {
                        if (index < 20) { // Limit to 20 items
                            return (
                                <div key={business.bookingId} className="business-item">
                                    <Link to={`/user/business-view/${business.bookingId}`}>
                                        <div className="mx-1 business_right">
                                            <div className="categoryImg">
                                                {/* Display the first image from the images array */}
                                                <img
                                                    onError={this.service_image_err}
                                                    className="imgBg"
                                                    src={
                                                        business.images && business.images[0]
                                                            // ? `https://services.hitasoft.in/juan/public/img/bookings/${business.images[0]}`
                                                            ? `https://emprende.net/public/img/bookings/${business.images[0]}`
                                                            : require("../../assets/images/default_service_image.png")
                                                    }
                                                    alt="Business Image"
                                                    height={135}
                                                />
                                            </div>
                                            {/* Display booked name */}
                                            <div className='business_wholecontent'>
                                            <div>
                                            <h4 className="category-name" >{business.mainCategory.name}</h4>
                                            <p className="subcategory-name">{business.subCategory.name}</p>
                                            </div>
                                            <h3 className="price">USD {Math.floor(business.new_price)?.toLocaleString('en-US')}</h3>
                                            </div>
                                            <div className='business_location'>
                                                <img src={locationnew} />
                                                <p className="city-name">{business.city}</p>
                                               , <p className="city-name">{business.country}</p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            );
                        }
                        return null;
                    })
                }
            </div>
        );
    }
}

export default BusinessForSaleSlider;